import React from 'react'
import { Box, Typography } from '@material-ui/core'
import useStyles from './styles'
import classnames from 'clsx'
import { useSelector } from 'react-redux'

const DonationsMessage = () => {
  const classes = useStyles()
  const orientation = useSelector(state => state.window.orientation)

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      className={classnames(classes.donationsMessage, classes[orientation])}
    >
      <Box margin="auto">
        <Typography className={classes.donateNowText} variant="h2">
          Donate Now!
        </Typography>
      </Box>
    </Box>
  )
}

export default DonationsMessage



// WEBPACK FOOTER //
// ./src/components/DonationsMessage/index.jsx